import gql from 'graphql-tag';

export const addGalerie = gql`
  mutation addGalerie($input: [GalerieInput!]!) {
    response: addGalerie(inputGalerie: $input) {
      id
    }
  }
`;
